import { environment } from 'src/environment';
import {
  NoSearcResultHeading,
  NoSearcResultStyled,
  NoSearchResultDescription,
  NoSearchResultLink,
} from './search-no-result.styled';

import { EmptyState, SvgEmptyStateSearchXSmall } from '@galaxy-react/core';
import { SearchNoResultGenericProps } from './search-no-result.types';

export function SearchNoResultGeneric(props: SearchNoResultGenericProps) {
  return (
    <NoSearcResultStyled key="freeform">
      <EmptyState
        description={
          <NoSearchResultDescription>
            Can't find what you're looking for? Try searching
            <NoSearchResultLink target="_blank" href={environment.helpCenterUrl}>
              Help Center
            </NoSearchResultLink>
          </NoSearchResultDescription>
        }
        headline={<NoSearcResultHeading variant="bodyLarge">No reports found</NoSearcResultHeading>}
        paddingBottom={0}
        illustration={<SvgEmptyStateSearchXSmall />}
      />
    </NoSearcResultStyled>
  );
}

export default SearchNoResultGeneric;
